import ChestsList from './components/ChestsList';
import AnimatedBackground from '../../Components/AnimatedBackground';

function Chests() {
  return (
    <div className="px-4 mt-3">
      <AnimatedBackground backgroundPage="chests" />
      <h1 className="font-Bangers text-[26px] mb-6 relative z-[1]">Chests</h1>
      <ChestsList />
    </div>
  );
}

export default Chests;
